module.exports = __webpack_public_path__ + "img/03-title.f59dcd34.png";